import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import PriceFormatter from '../../Common/priceFormatter';
import CashFormatter from '../../Common/cashFormatter';
import CellFormatter from '../../Common/cellFormatter';
import DateFormatter from './dateFormatter';
import { isDAICHEONG } from '../../../actions/root_url';
import { isVAK } from '../../../actions/root_url'

const propTypes = {
  onSalesInvoiceNumDoubleClick: PropTypes.func.isRequired,
  onSalesReturnNumDoubleClick: PropTypes.func.isRequired,
  minHeight: PropTypes.number,
};

const defaultProps = {
  minHeight: 150,
};

class CustomerStatementDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.rows,
      sortColumn: null,
      sortDirection: null,
    };
  }

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = (i) => JSON.parse(JSON.stringify(this.getRows()[i]));

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState(prevState => ({
      ...prevState,
      sortColumn,
      sortDirection,
    }));
  }

  render() {
    const {
      minHeight,
      onSalesInvoiceNumDoubleClick,
      onSalesReturnNumDoubleClick,
    } = this.props;
    // const columns = [
    //   {
    //       key: 'invoice_number',
    //       name: <Translate value="invoice_no" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 100,
    //   },
    //   {
    //       key: 'invoice_date',
    //       name: <Translate value="invoice_date" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 90,
    //       formatter: DateFormatter,
    //   },
    //   {
    //       key: 'due_date',
    //       name: <Translate value="due_date" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 90,
    //       formatter: DateFormatter,
    //   },
    //   {
    //       key: 'payment_received_date',
    //       name: <Translate value="pmt_rcv_date" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: DateFormatter,
    //       width: 90,
    //   },
    //   {
    //       key: 'ar_number',
    //       name: <Translate value="a"r_#' />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CellFormatter,
    //       width: 100,
    //   },
    //   {
    //       key: 'invoice_amount',
    //       name: <Translate value="invoice_amount" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: PriceFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'balance',
    //       name: <Translate value="invoice_balance" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: PriceFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'payment_received_amount',
    //       name: <Translate value="pmt_rcv_amount" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: PriceFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'remaining_balance',
    //       name: <Translate value="balance" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: PriceFormatter,
    //       width: 80,
    //       getRowMetaData: (row) => row,
    //   },
    //   {
    //       key: 'type',
    //       name: <Translate value="type" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CellFormatter,
    //       width: 150,
    //   },
    // ];
    const columns = [
      {
          key: 'PostingDate',
          name: <Translate value="date" />,
          resizable: true,
          sortable: true,
          formatter: DateFormatter,
          width: 90,
      },
      {
          key: 'Title',
          name: <Translate value="title" />,
          resizable: true,
          sortable: true,
          width: 120,
      },
      {
          key: 'InvoiceNum',
          name: <Translate value="invoice_no" />,
          resizable: true,
          sortable: true,
          formatter: ({ value, dependentValues }) => (
            <div
              onDoubleClick={() => {
                if (dependentValues.Title === "Credit Invoice") {
                  onSalesReturnNumDoubleClick(dependentValues.InvoiceId);
                } else if (value.substring(0, 2) === 'SI' || isDAICHEONG) {
                  onSalesInvoiceNumDoubleClick(dependentValues.InvoiceId);
                } else {
                  alert('Cannot print this invoice.');
                }
              }}
            >
              { value }
            </div>
        ),
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'PaymentStatus',
        name: <Translate value="pmt_status" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'UnpaidAmount',
        name: <Translate value="unpaid_amount" />,
        resizable: true,
        sortable: true,
        formatter: ({ value }) => (
          <div>
            { (value !== "" && value !== null) && '$'}
            { value }
          </div>
      ),
        width: 100,
      },
      ...isVAK ? [
        {
          key: 'Method',
          name: <Translate value="payment_method" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'BankAccount',
          name: <Translate value="account" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ]:[],
      {
          key: 'CheckNum',
          name: <Translate value="check_num" />,
          resizable: true,
          sortable: true,
          width: 100,
      },
      {
          key: 'Amount',
          name: <Translate value="charges" />,
          resizable: true,
          sortable: true,
          formatter: CashFormatter,
          width: 80,
      },
      {
          key: 'Payment',
          name: <Translate value="credits" />,
          resizable: true,
          sortable: true,
          formatter: CashFormatter,
          width: 80,
      },
      {
          key: 'Balance',
          name: <Translate value="balance" />,
          resizable: true,
          sortable: true,
          formatter: CashFormatter,
          width: 80,
      },
    ];
    return (
      <div id="CustomerStatementDetailTable-dataGrid1">
        <ReactDataGrid
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          headerRowHeight={45}
          minHeight={minHeight}
          rowGetter={this.rowGetter}
          rowsCount={this.getSize()}
        />
      </div>
    );
  }
}

CustomerStatementDetailTable.propTypes = propTypes;
CustomerStatementDetailTable.defaultProps = defaultProps;
export default CustomerStatementDetailTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/CustomerStatement/customerStatementDetailTable.jsx